import { Box, Grid, Typography } from "@material-ui/core";
import PreviewDocument from "components/PreviewDocument";
import moment from "moment";

const labelStyle = { color: "#666", marginBottom: "0.5rem" };
const valueStyle = { fontWeight: "bold" };

const CooperativeMemberInactivationDetails = ({
  memberData,
  inactivationDocument,
  previewDocumentPromise,
}) => {
  const hasPreviewableDocument = Boolean(inactivationDocument?.documentKey && inactivationDocument?.documentName);

  return (
    <Box mb={3}>
      <Typography variant="h3" style={{ color: "#002e9e", marginBottom: "1rem" }}>
        Motivo da Inactividade
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Box gridGap={2}>
            <Typography variant="body2" style={labelStyle}>
              Data da Inactividade
            </Typography>
            <Typography variant="body1" style={valueStyle}>
              {memberData?.inactivationDate ? moment(memberData.inactivationDate).format("DD/MM/YYYY") : "-"}
            </Typography>

            <Typography variant="body2" style={labelStyle}>
              Motivo
            </Typography>
            <Typography variant="body1" style={valueStyle}>
              {memberData?.inactivationReason || "-"}
            </Typography>

            {hasPreviewableDocument ? (
              <PreviewDocument
                title="Comprovativo de Inactivação"
                documents={[
                  {
                    documentId: inactivationDocument.documentKey,
                    documentName: inactivationDocument.documentName,
                  },
                ]}
                promise={previewDocumentPromise}
              />
            ) : (
              <>
                <Typography variant="body2" style={{ ...labelStyle, marginTop: "1rem" }}>
                  Comprovativo de Inactivação
                </Typography>
                <Typography variant="body1" style={{ ...valueStyle, marginBottom: "1rem" }}>
                  {inactivationDocument?.documentName || "-"}
                </Typography>
              </>
            )}

            <Typography variant="body2" style={labelStyle}>
              Responsável pela Inactivação
            </Typography>
            <Typography variant="body1" style={valueStyle}>
              {memberData?.inactivatedBy || "-"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CooperativeMemberInactivationDetails;